import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3, 0.3, 0),
  },
}));

const CompanyTabs = ({ active, onChange, modules, variant = 'entity' }) => {
  const classes = useStyles();
  const data = useSelector((state) => state[variant].data || {});

  const { documents = [], methodologies = [], issueCount, ratingNewsCount, researchCount } = data;
  const documentsTotal = documents.length + methodologies.length;
  const availableModules = modules.filter(({ spv }) => !data.spv || spv);

  const getLabel = (value, label) => {
    if (value === 'rating-news') return `${label} (${ratingNewsCount || 0})`;
    if (value === 'research') return `${label} (${researchCount || 0})`;
    if (value === 'instruments') return `${label} (${issueCount || 0})`;
    if (value === 'documents') return `${label} (${documentsTotal || 0})`;

    return label;
  };

  useEffect(() => {
    if (availableModules.some((item) => item.value === active)) return;

    onChange('companyModule', availableModules[0].value);
  }, [active, availableModules, onChange]);

  return (
    <div className={classes.container}>
      <Tabs
        value={active}
        indicatorColor="primary"
        textColor="primary"
        onChange={(_, value) => onChange('companyModule', value)}
        aria-label="Rating module tabs"
      >
        {availableModules.map(({ value, label }) => (
          <Tab key={value} label={getLabel(value, label)} value={value} />
        ))}
      </Tabs>
    </div>
  );
};

CompanyTabs.propTypes = {
  variant: PropTypes.string,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default CompanyTabs;
